// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"218":"1ca11c7a2d062898483b","691":"44f94f0ae7e02a5af98a"}[chunkId] + ".js";
};